import React, { Component } from 'react';
import css from './style.css';
import CSSModule from 'react-css-modules';
import { connect } from 'react-redux';

import TextFeild from '../../component/textFeild';
import $ from 'jquery';
import { browserHistory } from 'react-router'
import MemberData from '../../component/memberData';
import Title from '../../component/title';

import StudentData from '../../component/studentData';
import Button from '../../component/button';
import ClassBar from '../../component/classBar';

import { getUserInfo, updateProfile } from '../../actions';

const baseStudentData = {
	name: '',
	height: '',
	birth: '',
	gender: 'male' 
}

class Profile extends Component {
	constructor(props) {
		super(props);

		if(!props.userInfo.hasOwnProperty('students')) props.getUserInfo();

		this.state = {
			studentdData: props.studentdData || [baseStudentData]
		}

		this.studentRef = [];

		this.handleDoneClick = (e) => {
			let memberData = this.memberRef.state.formData;
			let studentData = [];

			// memberData.name = memberData.userName;
			memberData.username = memberData.email;

			for ( var i =0 ; i < this.studentRef.length; i++) {
				studentData.push(this.studentRef[i].state.formData);
			}

			const jsonData = Object.assign(memberData, { students: studentData});
			this.props.updateProfile(jsonData).then(()=>{
				browserHistory.push('/applyMain');
			});

		}
	}
	
	renderStudentList(  ) {

		var studentData = [];

		//if( !this.props.userInfo.hasOwnProperty('students')) return false;

		studentData = this.props.userInfo.students || [];

		if( studentData.length === 0 ) studentData.push(baseStudentData);
		const add = (e) => { 
			
			studentData.push(Object.assign({}, baseStudentData));
			this.setState(studentData);
		}
		return(
			<div style={{marginBottom:'20px'}}>
				<Title icon="pen4">學生資料</Title>
				{
					studentData.map((key, index) => {
						return <StudentData 
									firstTime={true} 
									key={index} 
									styleName="studentData" 
									ref={(ref) => this.studentRef[index] = ref} 
									formData={studentData[index]}/>
					})
				}
				<Button onClick={add}>新增下一個學生的資料</Button>
			</div>
		);
	}

	render() {
		
		const { userInfo } = this.props;
		return (
			<div styleName="">
                <MemberData firstTime={false} ref={(ref) => this.memberRef = ref} userInfo={ userInfo }/>
				{ this.renderStudentList(this.state.studentdData) }
				
				{/*<ClassBar content="123" type="simple" styleName="i_bar"/>
				<ClassBar content="123" type="simple" styleName="i_bar"/>
				<ClassBar content="123" type="simple" styleName="i_bar"/>*/}
				<Button onClick={this.handleDoneClick}>完成</Button>
			</div>
		);
	}
}

const mapStateToProps = state => {
	//console.log(state);
	return { 
		userInfo: state.data.user
	};
}

export default connect(mapStateToProps, { getUserInfo, updateProfile })(CSSModule(Profile,css));



/** WEBPACK FOOTER **
 ** ./src/container/profile/index.js
 **/